module.exports = __webpack_public_path__ + "static/photo-3-26c45f82fcd54d132c37b08e82058742.jpg";